/* DXB Trendia – small vanilla enhancements (sticky add-to-cart, recently viewed). No dependencies. */
(function () {
  'use strict';

  // Sticky add-to-cart bar
  document.querySelectorAll('.trendia-sticky').forEach(function (bar) {
    var sid = bar.getAttribute('data-section');
    var mainBtn = document.getElementById('ProductSubmitButton-' + sid);
    if (!mainBtn || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var btn = bar.querySelector('[data-sticky-btn]');
    var price = bar.querySelector('[data-sticky-price]');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('trendia-sticky-on', past);
    }).observe(mainBtn);
    btn.addEventListener('click', function () {
      if (mainBtn.disabled) { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      mainBtn.click();
    });
    // keep label/price in sync with variant changes
    new MutationObserver(function () {
      btn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('span');
      if (label) btn.textContent = label.textContent.trim();
      var p = document.querySelector('#price-' + sid + ' .price-item--sale, #price-' + sid + ' .price-item--regular');
      if (p && price) price.textContent = p.textContent.trim();
    }).observe(mainBtn, { attributes: true, childList: true, subtree: true });
  });

  // Recently viewed
  var rv = document.querySelector('[data-trendia-recent]');
  if (rv) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('trendia_recent') || '[]'); } catch (e) {}
    var current = rv.getAttribute('data-current');
    var limit = parseInt(rv.getAttribute('data-limit'), 10) || 4;
    list = list.filter(function (h) { return h && h !== current; }).slice(0, limit);
    if (list.length) {
      var fmtEl = document.querySelector('[data-trendia-money-format]');
      var fmt = '{{amount}}';
      try { fmt = JSON.parse(fmtEl.textContent); } catch (e) {}
      var money = function (cents) {
        var v = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
      };
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(list.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (items) {
        var ul = rv.querySelector('[data-trendia-recent-list]');
        items.filter(Boolean).forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'trendia-recent__item';
          var a = document.createElement('a');
          a.href = p.url;
          if (p.featured_image) {
            var img = document.createElement('img');
            var src = p.featured_image.replace(/^https?:/, '');
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
            img.alt = p.title; img.loading = 'lazy'; img.width = 400; img.height = 400;
            a.appendChild(img);
          }
          var t = document.createElement('span'); t.className = 'trendia-recent__title'; t.textContent = p.title;
          var pr = document.createElement('span'); pr.className = 'trendia-recent__price'; pr.textContent = money(p.price);
          a.appendChild(t); a.appendChild(pr); li.appendChild(a); ul.appendChild(li);
        });
        if (ul.children.length) rv.hidden = false;
      });
    }
  }
})();
